export default {
  homeLink: 'CrewPresence home',
  heroTitle1: "Know who's on site.",
  heroTitle2: 'Right now.',
  heroBody: "Company phones detect site arrivals and departures automatically. This portal shows who's on site, and the history behind it.",
  signIn: 'Sign in',
  mfaSubtitle: "Two-step verification. Confirm it's you to finish signing in.",
  loginSubtitle: 'Use the account your administrator set up for you.',
  restoreFailed: "Couldn't reach the server to restore your session.",
  retrying: 'Retrying…',
  recoveryCode: 'Recovery code',
  authenticatorCode: 'Authenticator code',
  recoveryCodeHint: 'Enter one of the recovery codes you saved. Each works once.',
  authenticatorCodeHint: 'Enter the 6-digit code from your authenticator app.',
  verifying: 'Verifying…',
  verifyAndSignIn: 'Verify and sign in',
  useAuthenticatorCode: 'Use authenticator code',
  useRecoveryCode: 'Use a recovery code',
  emailPlaceholder: 'you@company.com',
  password: 'Password',
  hidePassword: 'Hide password',
  showPassword: 'Show password',
  rememberMe: 'Remember me',
  forgotPassword: 'Forgot password?',
  microsoftFailed: "Microsoft sign-in didn't work. Check the email is right and that your company has turned it on, or use your password.",
  signingIn: 'Signing in…',
  signInWithMicrosoft: 'Sign in with Microsoft',
  enterEmailFirst: 'Enter your work email above first.',
  noAccount: 'No account yet? <link>Request a demo to start your free trial</link>',
  checkEmail: 'Check your email',
  checkEmailBody: "If an account exists for <b>{email}</b>, we've sent a link to reset the password. It expires in 30 minutes.",
  backToSignIn: 'Back to sign in',
  resetTitle: 'Reset your password',
  resetSubtitle: "Enter the email on your account and we'll send you a link to choose a new password.",
  sending: 'Sending…',
  sendResetLink: 'Send reset link',
  linkInvalid: 'Link is invalid',
  inviteLinkMissingToken: 'This invite link is missing its token. Ask an admin to resend it.',
  resetLinkMissingToken: 'This reset link is missing its token. Request a new one to continue.',
  requestNewLink: 'Request a new link',
  passwordSet: 'Password set',
  passwordUpdated: 'Password updated',
  passwordSetBody: 'Your password is set. Sign in to get started.',
  passwordUpdatedBody: 'Your password has been changed. Sign in with your new password to continue.',
  welcomeChoosePassword: 'Welcome — choose a password',
  chooseNewPassword: 'Choose a new password',
  welcomeChoosePasswordBody: "You'll use this to sign in to CrewPresence.",
  chooseNewPasswordBody: "Pick something you haven't used before.",
  newPassword: 'New password',
  newPasswordHint: 'At least 8 characters.',
  confirmPassword: 'Confirm password',
  passwordsDontMatch: "Passwords don't match.",
  settingPassword: 'Setting…',
  updatingPassword: 'Updating…',
  setPassword: 'Set password',
  updatePassword: 'Update password',
  inviteUnavailable: "This invite isn't available",
  inviteUnavailableBody: 'The link may have expired or been replaced by a newer one. Ask your manager to send you a fresh invite. It only takes them a click.',
  inviteAllSet: "You're all set, {name}",
  inviteAllSetBody: 'Your phone is already connected to {company}. Open the CrewPresence app to see your shifts.',
  inviteWelcome: 'Welcome, {name}',
  inviteIntro: "Two quick steps and your phone is ready. There's no password to make up.",
  inviteOpenOnPhone: 'Open this page on your phone to continue. You can email it to yourself or scan a QR code of this address.',
  inviteStepInstallIos: 'Install the app (skip if you already have it)',
  inviteStepInstall: 'Install the app',
  inviteInstallIosBody: 'Install CrewPresence from the TestFlight invite your manager sent, then come back to this page.',
  inviteGetOnPlay: 'Get it on Google Play',
  inviteGetOnAppStore: 'Get it on the App Store',
  inviteInstallIosStoreBody: 'Tap Get in the App Store, then come back to this page.',
  inviteInstallAndroidBody: 'Tap Install in Google Play, then come back to this page.',
  inviteStepOpen: "Open it and you're paired",
  inviteOpenApp: 'Open CrewPresence',
  inviteOpenBody: 'Allow location and notifications when asked so check-ins work. Already using CrewPresence for another company? This adds {company} alongside it.',
  invitePinPrompt: "Type this code into the app's pairing screen:",
  invitePinValidFor: 'Valid for {time}',
  invitePinExpired: 'Expired. Get a new code.',
  inviteGetNewCode: 'Get a new code',
  inviteButtonDidntOpen: "Button didn't open the app?",
  inviteGettingCode: 'Getting code…',
  inviteShowPin: 'Show my pairing code instead',
}
